<template>
  <v-dialog v-model="dialogOpen" :persistent="true" max-width="600px">
    <v-form>
      <v-card>
        <v-card-title>
          <h4><v-icon>mdi-folder</v-icon>Tätigkeit</h4>
        </v-card-title>
        <v-card-text>
          <v-text-field
              v-model="name"
              label="Beschreibung"
              required
              :rules="rules"
          />
          <v-text-field
              v-model="position"
              label="Position"
              type="number"
              min="0"
              required
              :rules="rules"
          />
          <v-select
              :items="extraCharges"
              item-text="code"
              item-value="id"
              v-model="extraChargeId"
              placeholder="Lohnart"
              hint="Lohnart"
              label="Lohnart"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="default" text @click="close" :disabled="actionsDisabled">Abbrechen</v-btn>
          <v-btn v-if="isExistingActivity && activity.isActive" color="error" class="white--text" @click="setInactive" :loading="isChangingActive" :disabled="actionsDisabled">
            <v-icon>mdi-eye-off</v-icon> Deaktivieren
          </v-btn>
          <v-btn v-else-if="isExistingActivity" color="success" class="white--text" @click="setActive" :loading="isChangingActive" :disabled="actionsDisabled">
            <v-icon>mdi-eye</v-icon> Aktivieren
          </v-btn>
          <v-btn color="primary" @click="save" :disabled="!valid || actionsDisabled" :loading="isSaving">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import timeparkApi from "@/timeparkApi";
const productsApi = timeparkApi.productsApi;

export default {
  name: 'ActivityDialog',
  props: {
    open: Boolean,
    activity: Object,
    orderId: String,
    productId: String,
  },
  computed: {
    dialogOpen: {
      get() {
        return this.open;
      },
      set(v) {
        this.$emit('update:open', v);
      }
    },
    isChangingActive() {
      return this.runningOperation === 'changeActive';
    },
    isSaving() {
      return this.runningOperation === 'save';
    },
    actionsDisabled() {
      return !!this.runningOperation;
    },
    valid() {
      return !!this.name && !! this.position;
    },
    isExistingActivity() {
      return this.activity && this.activity.id;
    },
    extraCharges() {
      return [
        {
          id: null,
          code: ' - ',
        }
        ,
        ...this.$store.state.extraCharges
      ]
    },
  },
  watch: {
    activity: {
      deep: true,
      handler: 'updateData'
    }
  },
  methods: {
    async setInactive() {
      this.runningOperation = 'changeActive';

      await productsApi.deactivateActivity(this.productId, this.orderId, this.activity.id);
      await this.$store.dispatch('loadProducts');

      this.runningOperation = null;
      this.close();
    },
    async setActive() {
      this.runningOperation = 'changeActive';

      await productsApi.reactivateActivity(this.productId, this.orderId, this.activity.id);
      await this.$store.dispatch('loadProducts');

      this.runningOperation = null;
      this.close();
    },
    async save() {
      const activity = {
        id: this.activity ? this.activity.id : null,
        number: this.number,
        patternNumber: this.patternNumber,
        name: this.name,
        position: this.position,
        extraChargeId: this.extraChargeId,
      };
      const apiOperation = activity.id ?
          productsApi.editActivity :
          productsApi.createActivity;
      this.runningOperation = 'save';

      await apiOperation(this.productId, this.orderId, activity);
      await this.$store.dispatch('loadProducts');

      this.runningOperation = null;
      this.close();
    },
    close() {
      this.updateData(null);
      this.$emit('close');
    },
    updateData(data) {
      this.name = data ? data.name : '';
      this.number = data ? data.number : null;
      this.patternNumber = data ? data.patternNumber : null;
      this.position = data ? data.position : null;
      this.extraChargeId = data ? data.extraChargeId : null;
    },
  },
  data() {
    return {
      name: '',
      number: null,
      patternNumber: null,
      position: null,
      extraChargeId: null,
      rules: [val => !!val || 'Dieses Feld darf nicht leer sein'],
      runningOperation: null,
    };
  },
};
</script>
